import { render } from "./PasswordInput.vue?vue&type=template&id=70b564f2&scoped=true&ts=true"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"

import "./PasswordInput.vue?vue&type=style&index=0&id=70b564f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b564f2"]])

export default __exports__